"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlParam = void 0;
const getUrlParam = key => {
  const queryString = window.location.search.split('+').join(' ');
  let tokens;
  const params = {};
  const re = /[?&]?([^=]+)=([^&]*)/g;
  while (tokens = re.exec(queryString)) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
  }
  return params[key];
};
exports.getUrlParam = getUrlParam;